export const setContainerParameters = 'setContainerParameters';
export const cleanSheetForPrint = 'cleanSheetForPrint';
export const addSheetForPrint = 'addSheetForPrint';
export const removeSheetForPrint = 'removeSheetForPrint';
export const setContainerPriceMaps = 'setContainerPriceMaps';
export const addContainersForSelect = 'addContainersForSelect';
